export const AvgUpTrendColor = '#F09837';

export const AvgDownTrendColor = '#37ADF0';
